import { Link } from "react-router-dom";

export default function ConsentFooter() {
  return (
    <footer className="bg-ink text-white/[.55] pt-12 pb-8 text-[0.9rem]">
      <div className="container mx-auto max-w-[1140px] px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="font-figtree font-bold text-[1.25rem] text-white inline-flex items-center gap-[0.55rem]">
              <img
                src="/assets/onedpdp-logo.png"
                alt=""
                width="32"
                height="32"
                className="h-8 w-8 object-cover rounded bg-white"
              />
              One<span className="text-gold">DPDP</span>
            </div>
            <p className="mt-2 max-w-[22rem]">
              Consent, discovery variance and DSAR — connected for India's DPDP
              Act.
            </p>
          </div>

          <div>
            <div className="text-[0.72rem] tracking-[0.1em] uppercase text-white/35 mb-[0.85rem]">
              On this page
            </div>
            <div className="flex flex-col gap-2">
              <a
                href="#audiences"
                className="hover:text-gold-bright transition-colors"
              >
                Audiences
              </a>
              <a
                href="#variance"
                className="hover:text-gold-bright transition-colors"
              >
                Consent Variance
              </a>
              <a
                href="#channels"
                className="hover:text-gold-bright transition-colors"
              >
                Email &amp; WhatsApp
              </a>
              <a
                href="#templates"
                className="hover:text-gold-bright transition-colors"
              >
                Industry templates
              </a>
              <a
                href="#cookies"
                className="hover:text-gold-bright transition-colors"
              >
                Cookie consent
              </a>
              <a
                href="#dsar"
                className="hover:text-gold-bright transition-colors"
              >
                DSAR
              </a>
            </div>
          </div>

          <div>
            <div className="text-[0.72rem] tracking-[0.1em] uppercase text-white/35 mb-[0.85rem]">
              Platform
            </div>
            <div className="flex flex-col gap-2">
              <Link
                to="/explore"
                className="hover:text-gold-bright transition-colors"
              >
                Home
              </Link>
              <Link
                to="/explore#platform"
                className="hover:text-gold-bright transition-colors"
              >
                All modules
              </Link>
              <Link
                to="/explore#discovery"
                className="hover:text-gold-bright transition-colors"
              >
                Data Discovery
              </Link>
              <a
                href="mailto:sales@onedpdp.com"
                className="hover:text-gold-bright transition-colors"
              >
                sales@onedpdp.com
              </a>
            </div>
          </div>
        </div>

        <hr className="border-white/[.08] my-8" />

        <div className="flex flex-col md:flex-row justify-between gap-2">
          <span>&copy; 2026 OneDPDP. All rights reserved.</span>
          <span>
            <a href="#" className="hover:text-gold-bright transition-colors">
              Privacy Policy
            </a>
            &nbsp;·&nbsp;
            <a href="#" className="hover:text-gold-bright transition-colors">
              Terms of Service
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
